import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import OpterraPhoenixLogo from 'assets/images/OpterraPhoenixLogo.png';
import Notification from 'components/common/Notification';
import { SIDEBAR_INFO_BANNER_STORAGE_KEY } from 'constants/uiConstants';
import { RootState } from 'redux/Store';

import { setSidebarInfoBannerVisible } from '../../../redux/slices/FarmSlice';

const OrganisationInfoBanner = () => {
  const dispatch = useDispatch();
  const visible = useSelector(
    (state: RootState) => state.farmReducer.sidebarInfoBannerVisible
  );

  const handleClose = () => {
    localStorage.setItem(SIDEBAR_INFO_BANNER_STORAGE_KEY, 'false');
    dispatch(setSidebarInfoBannerVisible(false));
  };

  if (!visible) return null;

  return (
    <Notification
      type="primary"
      className="mb-2"
      closable
      handleClose={handleClose}
      icon={
        <img
          src={OpterraPhoenixLogo}
          alt="Logo"
          className="mt-1 h-4 w-auto brightness-0 invert"
        />
      }
    >
      <span className="text-sm">
        Click <b>Change</b> next to the <b>Organisation name</b> to switch.
        Single-click a tree node to <b>select</b>, double-click to{' '}
        <b>expand / collapse</b>. Hover over a Paddock and click <b>+</b> to add
        more plans, right-click a plan to <b>delete</b> it.
      </span>
    </Notification>
  );
};

export default OrganisationInfoBanner;
